const CURRENCY_KEYS = {
  DOLLAR: 'US$',
  EURO: '€',
  POUND: '£',
  YEN: '¥',
  YUAN: 'CN¥',
  FRANC: 'CHF',

  CAD: 'CA$',
  AUD: 'AU$',
  NZD: 'NZ$',

  RSD: 'RSD',
  NOK: 'kr',
  SEK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  CZK: 'Kč',
  HUF: 'Ft',
  RON: 'lei',
  BGN: 'лв',

  INR: '₹',
  KRW: '₩',
  TRY: '₺',
  THB: '฿',
  IDR: 'Rp',
  PHP: '₱',
  VND: '₫',

  AED: 'AED',
  SAR: 'SAR',
  ILS: '₪',
  ZAR: 'R',
  NGN: '₦',
  EGP: 'E£',

  BRL: 'R$',
  MXN: 'MX$',
  ARS: 'AR$',
  CLP: 'CLP$',
  COP: 'CO$',
};

export const CURRENCIES = [
  {
    value: CURRENCY_KEYS.DOLLAR,
    name: 'US Dollar $',
    key: 'dollar',
  },
  {
    value: CURRENCY_KEYS.EURO,
    name: 'Euro €',
    key: 'euro',
  },
  {
    value: CURRENCY_KEYS.POUND,
    name: 'British Pound £',
    key: 'pound',
  },
  {
    value: CURRENCY_KEYS.YEN,
    name: 'Japanese Yen ¥',
    key: 'yen',
  },
  {
    value: CURRENCY_KEYS.YUAN,
    name: 'Chinese Yuan ¥',
    key: 'yuan',
  },
  {
    value: CURRENCY_KEYS.FRANC,
    name: 'Swiss Franc CHF',
    key: 'franc',
  },
  {
    value: CURRENCY_KEYS.CAD,
    name: 'Canadian Dollar $',
    key: 'cad',
  },
  {
    value: CURRENCY_KEYS.AUD,
    name: 'Australian Dollar $',
    key: 'aud',
  },
  {
    value: CURRENCY_KEYS.NZD,
    name: 'New Zealand Dollar $',
    key: 'nzd',
  },
  {
    value: CURRENCY_KEYS.RSD,
    name: 'Serbian Dinar RSD',
    key: 'rsd',
  },
  {
    value: CURRENCY_KEYS.NOK,
    name: 'Norwegian Krone kr',
    key: 'nok',
  },
  {
    value: CURRENCY_KEYS.SEK,
    name: 'Swedish Krona kr',
    key: 'sek',
  },
  {
    value: CURRENCY_KEYS.DKK,
    name: 'Danish Krone kr',
    key: 'dkk',
  },
  {
    value: CURRENCY_KEYS.PLN,
    name: 'Polish Zloty zł',
    key: 'pln',
  },
  {
    value: CURRENCY_KEYS.CZK,
    name: 'Czech Koruna Kč',
    key: 'czk',
  },
  {
    value: CURRENCY_KEYS.HUF,
    name: 'Hungarian Forint Ft',
    key: 'huf',
  },
  {
    value: CURRENCY_KEYS.RON,
    name: 'Romanian Leu lei',
    key: 'ron',
  },
  {
    value: CURRENCY_KEYS.BGN,
    name: 'Bulgarian Lev лв',
    key: 'bgn',
  },
  {
    value: CURRENCY_KEYS.INR,
    name: 'Indian Rupee ₹',
    key: 'inr',
  },
  {
    value: CURRENCY_KEYS.KRW,
    name: 'South Korean Won ₩',
    key: 'krw',
  },
  {
    value: CURRENCY_KEYS.TRY,
    name: 'Turkish Lira ₺',
    key: 'try',
  },
  {
    value: CURRENCY_KEYS.THB,
    name: 'Thai Baht ฿',
    key: 'thb',
  },
  {
    value: CURRENCY_KEYS.IDR,
    name: 'Indonesian Rupiah Rp',
    key: 'idr',
  },
  {
    value: CURRENCY_KEYS.PHP,
    name: 'Philippine Peso ₱',
    key: 'php',
  },
  {
    value: CURRENCY_KEYS.VND,
    name: 'Vietnamese Dong ₫',
    key: 'vnd',
  },
  {
    value: CURRENCY_KEYS.AED,
    name: 'UAE Dirham AED',
    key: 'aed',
  },
  {
    value: CURRENCY_KEYS.SAR,
    name: 'Saudi Riyal SAR',
    key: 'sar',
  },
  {
    value: CURRENCY_KEYS.ILS,
    name: 'Israeli Shekel ₪',
    key: 'ils',
  },
  {
    value: CURRENCY_KEYS.ZAR,
    name: 'South African Rand R',
    key: 'zar',
  },
  {
    value: CURRENCY_KEYS.NGN,
    name: 'Nigerian Naira ₦',
    key: 'ngn',
  },
  {
    value: CURRENCY_KEYS.EGP,
    name: 'Egyptian Pound E£',
    key: 'egp',
  },
  {
    value: CURRENCY_KEYS.BRL,
    name: 'Brazilian Real R$',
    key: 'brl',
  },
  {
    value: CURRENCY_KEYS.MXN,
    name: 'Mexican Peso $',
    key: 'mxn',
  },
  {
    value: CURRENCY_KEYS.ARS,
    name: 'Argentine Peso $',
    key: 'ars',
  },
  {
    value: CURRENCY_KEYS.CLP,
    name: 'Chilean Peso $',
    key: 'clp',
  },
  {
    value: CURRENCY_KEYS.COP,
    name: 'Colombian Peso $',
    key: 'cop',
  },
];
